import type {
  AdminChatConversationFacets,
  AdminChatConversationListItem,
  AdminChatConversationView,
  AdminStarredFacets,
  AdminStarredMessage,
  ApiResponse,
  PaginatedResponse,
} from '@klaro7/shared-types';

import api from '@/lib/api';

export async function starMessage(messageId: string): Promise<void> {
  await api.post(`/chat/messages/${messageId}/star`);
}

export async function unstarMessage(messageId: string): Promise<void> {
  await api.delete(`/chat/messages/${messageId}/star`);
}

export interface AdminStarredFilters {
  userId?: string;
  professionalId?: string;
  /** YYYY-MM-DD */
  from?: string;
  /** YYYY-MM-DD, inclusivo */
  to?: string;
  page?: number;
  limit?: number;
}

export async function getAdminStarred(
  filters: AdminStarredFilters
): Promise<PaginatedResponse<AdminStarredMessage>> {
  const params = Object.fromEntries(Object.entries(filters).filter(([, v]) => v !== undefined && v !== ''));
  const response = await api.get<PaginatedResponse<AdminStarredMessage>>('/chat/admin/starred', { params });
  return response.data;
}

export async function getAdminStarredFacets(): Promise<AdminStarredFacets> {
  const response = await api.get<ApiResponse<AdminStarredFacets>>('/chat/admin/starred/facets');
  return response.data.data;
}

export async function getAdminConversation(conversationId: string): Promise<AdminChatConversationView> {
  const response = await api.get<ApiResponse<AdminChatConversationView>>(
    `/chat/admin/conversations/${conversationId}`
  );
  return response.data.data;
}

// ─── Monitoraggio conversazioni ─────────────────────────────────────────────

export interface AdminConversationsFilters {
  /** Nome, cognome, nome d'arte o email di cliente o consulente. */
  q?: string;
  professionalId?: string;
  /** YYYY-MM-DD */
  from?: string;
  /** YYYY-MM-DD, inclusivo */
  to?: string;
  page?: number;
  limit?: number;
}

export async function getAdminConversations(
  filters: AdminConversationsFilters
): Promise<PaginatedResponse<AdminChatConversationListItem>> {
  const params = Object.fromEntries(
    Object.entries(filters).filter(([, v]) => v !== undefined && v !== '')
  );
  const response = await api.get<PaginatedResponse<AdminChatConversationListItem>>(
    '/chat/admin/conversations',
    { params }
  );
  return response.data;
}

export async function getAdminConversationFacets(): Promise<AdminChatConversationFacets> {
  const response = await api.get<ApiResponse<AdminChatConversationFacets>>(
    '/chat/admin/conversations/facets'
  );
  return response.data.data;
}
